import type { FaireProductEntity } from "../../entity_types/product";

export const p_5j8ymvey4m: FaireProductEntity = {
  token: "p_5j8ymvey4m",
  type: "product",
  name: "18K Gold PVD Stainless Steel Classic Hoop Huggie Earrings",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/d0ad4b9e601c196bc89fdf42d7c1c03f56cd0a3a02e0ae40d2f6a39f1322b0da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e9403a843db93f44f9bc62bab74de3154044ffcab1b7a0f97767d0c67e81da7.jpeg",
    "https://cdn.faire.com/fastly/23c8f552d7a4db98e1e5c4a8d86c7cf72806afa92b1ae64100e9a486a24f38e5.jpeg",
    "https://cdn.faire.com/fastly/320540a5d87daefea6ee584e1691fc0c3aebcee228da0e2c92c17b14eaffb997.jpeg",
    "https://cdn.faire.com/fastly/410a69af16bff5cb5dccd21367475e59f3684aa55639e491dae805a94c19babc.jpeg",
    "https://cdn.faire.com/fastly/c3d148e0c7daff524d0208a46e74bd30cf2a293a24f0bb4242731926806b03d7.jpeg",
  ],
  priceDollars: 1.37,
  description:
    "Enhance your selection of jewelry for the season with the Classic Hoop Huggie Earring! These simple, yet stunning huggie style hoops are versatile for a variety of occasions. The Classic Hoop Huggie Earrings are great as a stand alone seller, but are the perfect option to be paired with other huggies or stud earrings for a stacked look.\n\nExplore our complete Earring Collection to start building your own assortment of stacked earring looks!\n\n• Lightweight & perfect for everyday wear or special occasions!\n• Made with 316L Surgical Steel - Hypoallergenic, non-tarnish, 100% waterproof\n\n-𝐏𝐕𝐃 𝐂𝐨𝐚𝐭𝐢𝐧𝐠-\nWe use the process of PVD Coating our 18K Gold jewelry over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer's skin green.\n\nApprox. Weight: 1.31 grams (8mm) / 1.33 grams (10mm) / 1.49 grams (12mm) / 1.88 grams (16mm)\nApprox. Width: 1.6mm",
  tags: [],
  msrpDollars: 12.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:29.601Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
